// extracted by mini-css-extract-plugin
export default {"hot_list_container":"hot-list_hot_list_container__n50nF"};